module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', {
    staticClass: "mobile-no-margin"
  }, [_vm._v("\n      БЕЗОПАСНАЯ СДЕЛКА\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col li-cancel"
  }, [_c('p', {
    staticClass: "cansel-text",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_c('ui_sub_title_text', [_vm._v("Безопасные переводы между физическими лицами")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Деньги придут, когда услуга будет оказана")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Ваш расчетный счет не участвует в сделке")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Длительная заморозка денег заказчика")])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/search"
    }
  }, [_c('ui_btn', {
    attrs: {
      "type": "main-btn"
    }
  }, [_vm._v("Найти адвоката")])], 1)], 1)])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ТЕХНОЛОГИЯ РАБОТЫ\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row cancel-col-button"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('router-link', {
    attrs: {
      "to": "/search"
    }
  }, [_c('ui_btn', {
    attrs: {
      "type": "main-btn"
    }
  }, [_vm._v("Провести сделку")])], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-img-cancel"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/pc-new.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col img-only-cancel"
  }, [_c('img', {
    staticClass: "is-desctop-s",
    attrs: {
      "src": "/static/img/bezopas.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "is-mobile-s",
    attrs: {
      "src": "/static/img/mobile-bezopas.svg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-788c6d66","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Safety/safety.vue
// module id = 364
// module chunks = 2